import React from 'react';
import { Formik, Field, Form } from 'formik';
import { graphql } from 'react-apollo';
import { pick } from 'lodash';
import { UPDATE_COMPANY_WEBSITES } from '-/gql/company';
import { TextInput } from '-/components/inputs';
import Toolbar from '-/components/profiles/forms/Toolbar';
import styled from 'styled-components';
const StyledStandardForm = styled(Form)`
    padding: 15px;
    min-width: 350;
`;
const renderFields = props => {
    const { className, closeOverlay } = props;
    return (
        <StyledStandardForm className={className}>
            <Field name="homepage" component={TextInput} label="Home page" />
            <Field name="linkedin" component={TextInput} label="LinkedIn" />
            <Field name="twitter" component={TextInput} label="Twitter" />
            <Field name="facebook" component={TextInput} label="Facebook" />
            <Toolbar handleCancel={closeOverlay} />
        </StyledStandardForm>
    );
};

const WebsiteForm = props => {
    const { _id, closeOverlay, update, initialValues, className } = props;
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async values => {
                try {
                    const input = pick(values, [
                        'homepage',
                        'linkedin',
                        'twitter',
                        'facebook'
                    ]);
                    await update({
                        variables: {
                            _id,
                            input
                        }
                    });
                    closeOverlay();
                } catch (ex) {
                    console.warn(ex);
                }
            }}
            render={renderProps => {
                return renderFields({
                    ...renderProps,
                    closeOverlay,
                    className
                });
            }}
        />
    );
};

export default graphql(UPDATE_COMPANY_WEBSITES, { name: 'update' })(
    WebsiteForm
);
